import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { companyInfo } from '@/mocks/company';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/maquina-de-solda-de-geomembrana', label: 'Máquinas' },
  { to: '/aplicacoes', label: 'Aplicações' },
  { to: '/soldagem-de-geomembrana', label: 'Técnicas' },
  { to: '/sobre', label: 'Sobre' },
  { to: '/contato', label: 'Contato' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

  // O header transparente com texto branco só faz sentido na home (que tem imagem escura no topo).
  // Nas demais páginas o topo é claro, então o header deve ser sempre sólido para o texto ficar visível.
  const showSolid = isScrolled || location.pathname !== '/';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        showSolid
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex flex-col items-start flex-shrink-0 leading-none">
          <span className="flex items-center">
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-wide uppercase transition-colors ${
                showSolid ? 'text-foreground-950' : 'text-white'
              }`}
            >
              Máquina de Solda
            </span>
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-wide uppercase ml-1 transition-colors ${
                showSolid ? 'text-primary-500' : 'text-primary-400'
              }`}
            >
              Geomembrana
            </span>
          </span>
          <span
            className={`mt-1.5 text-[10px] md:text-xs font-medium tracking-wide transition-colors ${
              showSolid ? 'text-foreground-500' : 'text-white/70'
            }`}
          >
            DA EMPRESA SOLDAGEO IMPORTACOES
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 rounded-full text-xs font-semibold tracking-wider transition-all duration-200 cursor-pointer whitespace-nowrap uppercase ${
                showSolid
                  ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white text-xs font-bold px-4 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            <i className="ri-whatsapp-line text-sm"></i>
            WhatsApp
          </a>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-all ${
            showSolid ? 'text-foreground-950 hover:bg-background-100' : 'text-white hover:bg-white/10'
          }`}
          aria-label="Menu"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-background-50 border-t border-background-200/70 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm text-foreground-600 hover:text-primary-600 py-2.5 border-b border-background-200/50 cursor-pointer uppercase tracking-wide font-medium"
            >
              {link.label}
            </Link>
          ))}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-3 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white text-sm px-4 py-3 rounded-full cursor-pointer whitespace-nowrap font-bold uppercase tracking-wide"
          >
            <i className="ri-whatsapp-line"></i>
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}